import {
  SET_DATA,
  SET_ENDPOINT,
  SET_SEARCH_QUERY,
  SET_STOREDATA,
  SET_CURRENCY_SYMBOL,
  SET_ORDER_DATA,
  SET_USER_LOACATION,
  SET_THEME_COLOR,
  SET_APP_CONFIGS,
  IS_FETCHING_APP_CONFIGS,
} from "./types";
import { resolveEndpoint } from "../Common/utils";

const initialState = {
  userdata: {
    Date: "",
    Time: "",
    Adults: 0,
    Child: 0,
    Infants: 0,
  },
  endpoint: resolveEndpoint(),
  store: {
    id: 0,
    name: "",
    image: "",
  },
  userLocation: null,
  searchText: "",
  themeColor: "#162A5C", // Default theme color
  appConfigs: [],
  countries: [],
  selectedCountry: {},
  isFetchingAppConfigs: false,
  orderData: null, // { order } for pay-at-table / active order
  currencySymbol: "",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        userdata: {
          ...state.userdata,
          ...action.data,
        },
      };

    case SET_ENDPOINT:
      return {
        ...state,
        endpoint: action.data,
      };

    case SET_STOREDATA:
    // console.log("SET_STOREDATA action.data", action.data);
      return {
        ...state,
        store: {
          ...state.store,
          ...action.data,
        },
      };

    case SET_CURRENCY_SYMBOL:
      return {
        ...state,
        currencySymbol: action.data,
      };

    case SET_ORDER_DATA:
      return {
        ...state,
        orderData: action.data,
      };

    case SET_USER_LOACATION:
      return {
        ...state,
        userLocation: action.data,
      };

    case SET_SEARCH_QUERY:
      return {
        ...state,
        searchText: action.data,
      };

    case SET_THEME_COLOR:
      return {
        ...state,
        themeColor: action.data,
      };

    case SET_APP_CONFIGS:
      const countries = action.data.country;
      return {
        ...state,
        appConfigs: action.data.data,
        countries: countries,
      };

    case IS_FETCHING_APP_CONFIGS:
      return {
        ...state,
        isFetchingAppConfigs: action.data,
      };

    default:
      return state;
  }
};
